;jQuery.ajaxSetup({
  accepts: {
    fragment: "text/x-html-fragment"
  },
  contents: {
    script: /fragment/
  },
  converters: {
    "text fragment": true
  }
});



// WEBPACK FOOTER //
// ./app/javascript/lib/vendor_extensions/jquery.rails-fragments.js